<template>
  <div id="app">
    <keep-alive exclude="tnc">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>

export default {
    name: 'app',
    //props: ['lang', 'langObj', 'params'],
    /*components: {
        Header,
        Coupon,
    },*/
    /*data: function() {
        return {
        }
    },*/
    created() {
        //console.log(this.langObj);
        //console.log(this.params);
    }
};
</script>
